/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import { useCreateReplenishmentOpenOrders } from "utils/apis/replenishment.api";
import { showToast } from "utils/helper";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@repo/ui";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { formatDate } from "date-fns";

interface DenominationDetail {
  denomination: string;
  noOfNotes: number;
}

interface LocationDetail {
  barcode: string;
  invoicingModel: string;
  jobNature: string;
  routeNo: string;
  priority: number;
  denominations: DenominationDetail[];
  expanded?: boolean;
}

interface DetailComponentProps {
  dataItem: LocationDetail;
}

function DetailComponent({ dataItem }: DetailComponentProps) {
  const data = dataItem.denominations;

  if (data && data.length > 0) {
    return (
      <Grid data={data}>
        <Column field="denomination" title="Denomination" />
        <Column field="noOfNotes" title="No of Notes" />
      </Grid>
    );
  }

  return <div style={{ height: "50px", width: "100%" }} />;
}

export default function OpenModelRequests({
  openFileUpload,
  setOpenFileUpload,
}: {
  openFileUpload: boolean;
  setOpenFileUpload: (open: boolean) => void;
}) {
  const [openModelLocations, setOpenModelLocations] = useState<
    LocationDetail[]
  >([]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  const {
    mutate: createOpenModelOrders,
    isSuccess: openModelOrdersSuccess,
    isError: openModelOrdersError,
    isPending: openModelOrdersPending,
  } = useCreateReplenishmentOpenOrders();

  useEffect(() => {
    if (openModelOrdersSuccess) {
      showToast("success", "Open model orders created successfully!");
      setOpenModelLocations([]);
      setOpenFileUpload(false);
    }
    if (openModelOrdersError) {
      showToast("error", "Failed to create open model orders.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModelOrdersSuccess, openModelOrdersError]);

  const fileHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileObj = event.target.files?.[0];

    if (!fileObj) return;

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        const rows = resp.rows;
        const columns = resp.cols;

        const locations: LocationDetail[] = [];
        const denominations: { denomination: string }[] = [];
        const denomsCount = columns.length;

        // Read denomination names from first row starting from column 5
        for (let index = 5; index < denomsCount; index++) {
          const denom = rows[0][index];
          if (denom) {
            denominations.push({ denomination: denom });
          }
        }

        // Parse each row as location + denominations
        for (let index = 1; index < rows.length; index++) {
          const barcode = rows[index][0];
          const invoicingModel = rows[index][1];
          const jobNature = rows[index][2];
          const priority = parseInt(rows[index][3]);
          const routeNo = rows[index][4];

          if (barcode) {
            const replenishedDenominations: DenominationDetail[] = [];

            denominations.forEach((dnm, ind) => {
              const noOfNotes = parseInt(rows[index][ind + 5]);
              if (noOfNotes && noOfNotes > 0) {
                replenishedDenominations.push({
                  denomination: dnm.denomination,
                  noOfNotes,
                });
              }
            });

            if (replenishedDenominations.length > 0) {
              locations.push({
                barcode: barcode.toString(),
                invoicingModel,
                jobNature,
                routeNo,
                priority,
                denominations: replenishedDenominations,
              });
            }
          }
        }

        if (locations.length > 0) {
          setOpenModelLocations(locations);
        } else {
          showToast("error", "No data found in excel file.");
        }
      }
    });
  };

  const handleCreateOrders = () => {
    if (!selectedDate) {
      return showToast("error", "Please select service date and time.");
    }

    const payload = {
      serviceDateTime: formatDate(selectedDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      locations: openModelLocations,
    };

    createOpenModelOrders(payload);
  };

  const expandChange = (event: {
    dataItem: LocationDetail;
    value: boolean;
  }) => {
    event.dataItem.expanded = event.value;
    setOpenModelLocations([...openModelLocations]);
  };

  const handleCloseModal = () => {
    setOpenModelLocations([]);
    setOpenFileUpload(false);
  };

  return (
    <Dialog open={openFileUpload} onOpenChange={handleCloseModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Open Model Orders</DialogTitle>
        </DialogHeader>
        <DialogDescription className="pt-6 space-y-4 max-h-[70vh] overflow-auto">
          {/* Preview Locations */}
          {openModelLocations.length ? (
            <Grid
              data={openModelLocations}
              detail={DetailComponent}
              expandField="expanded"
              onExpandChange={expandChange}
            >
              <Column field="barcode" title="Barcode" />
              <Column field="invoicingModel" title="Invoicing Model" />
              <Column field="jobNature" title="Job Nature" />
              <Column field="routeNo" title="Route No" />
              <Column field="priority" title="Priority" />
            </Grid>
          ) : (
            <>
              <DateTimePicker
                placeholder="Select Service Date"
                className="w-full h-10"
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(e.target.value as Date);
                }}
                min={new Date()}
              />
              <div className="flex items-center justify-center w-full">
                <label
                  htmlFor="dropzone-open-model"
                  className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                >
                  <p className="mb-2 text-sm text-gray-500">
                    <span className="font-semibold">Click to upload</span> or
                    drag & drop
                  </p>
                  <p className="text-xs text-gray-500">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                  <input
                    id="dropzone-open-model"
                    accept=".xlsx, .xls, .csv"
                    type="file"
                    className="hidden"
                    onChange={fileHandler}
                  />
                </label>
              </div>
            </>
          )}

          {/* Submit Button */}
          <div className="flex justify-end mt-4 gap-2">
            <Button
              variant="outline"
              onClick={() => {
                setOpenModelLocations([]);
                setOpenFileUpload(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              disabled={openModelOrdersPending || !openModelLocations?.length}
              onClick={handleCreateOrders}
            >
              {openModelOrdersPending ? "Creating..." : "Create Request"}
            </Button>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}
